<template>
  <b-container class="app-container" fluid>
    <router-view />
  </b-container>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
.app-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 60px;
}
</style>
